// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"FrontPage_subtitle__1PC86","button":"FrontPage_button__2d-17"};